import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
import axios from "axios";

import { toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
//import InfiniteScroll from 'react-infinite-scroll-component';
import FriendItem from "../../components/my/FriendItem";
import { isMobile, isAndroid, isIOS } from "react-device-detect";

class MyFriendList extends Component {
  state = {
    gotoPage: 1,
    pageCount: 1,
    pageSize: 10,
    dataList: [],
    allSelect: false,
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    this._getData(1);
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _getData = async (gotoPage) => {
    const { loginId } = this.props;

    if (loginId === null || loginId === undefined || loginId === "") {
    } else {
      const result = await this._getDataApi(gotoPage);
      if (result) {
        const intReturn = result.data[0].intReturn;
        const pageCount = result.data[0].pageCount;
        const con = result.data[0].con;
        const cash = result.data[0].cash;
        const dataList = result.data[0].listData;

        //console.log(dataList)
        if (this._isMounted) {
          if (intReturn === 0) {
            if (con > 0) {
              //console.log('con > 0')
              this.setState({
                gotoPage: gotoPage,
                con: con,
                pageCount: pageCount,
                dataList: dataList,
                cash: cash,
              });
            } else {
              //console.log('con < 0')
              this.setState({
                gotoPage: 1,
                con: con,
                dataList: dataList,
                cash: cash,
              });
            }
          } else {
            //console.log('intReturn <> 0')
            this.setState({
              gotoPage: 1,
              con: con,
              dataList: [],
              cash: cash,
            });
          }
        }
      }
    }
  };
  _getDataApi = (gotoPage) => {
    const { apiUrl, loginId, pageSize, history } = this.props;
    const at = localStorage.getItem("at");

    return axios
      .post(
        apiUrl + "/myChuchonList",
        {
          params: {
            userid: loginId,
            gotoPage: gotoPage,
            pageSize: pageSize,
          },
        },
        {
          headers: {
            Authorization: "bearer " + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(gotoPage);
        } else if (error.response.status === 400) {
          history.push("/login");
        }
      });
  };
  _refreshToken = async (gotoPage) => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    const rt = localStorage.getItem("rt");

    if (rt === "" || rt === undefined || rt === null) {
      history.push("/login");
      return false;
    }

    const { data } = await axios.post(apiUrl + "/refreshToken", {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem("at", data[0].at);
      this._getData(gotoPage);
    } else {
      this.setCookie("account", "");

      setLoginId("");
      setAuthId("");

      setTimeout(() => {
        history.push("/login");
      }, 500);
    }
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = "";
    }
    document.cookie =
      name +
      "=" +
      value +
      ";expires=" +
      expires +
      ";path=/; SameSite=None; Secure; domain=aniplustv.com";
  };
  _renderItem = () => {
    const { dataList } = this.state;
    const list = dataList.map((item, index) => {
      return (
        <FriendItem
          key={index}
          index={index}
          idx={item.idx}
          buyUserid={item.buyUserid}
          charac_img={item.charac_img}
          nicName={item.nicName}
          regDate={item.regDate}
          autoFlag={item.autoFlag}
          wishCount={item.wishCount}
          wishShare={item.wishShare}
        />
      );
    });

    return list;
  };

  _renderPage = () => {
    const { gotoPage, con, pageCount } = this.state;

    const dataPerPage = isMobile ? 5 : 10; //한페이지에 보여질 갯수
    let pageCount1;

    if (pageCount > dataPerPage) {
      pageCount1 = dataPerPage;
    } else {
      pageCount1 = pageCount;
    }
    const pageNumbers = [];

    const totalPage = Math.ceil(con / dataPerPage); //총페이지수

    const pageGroup = Math.ceil(gotoPage / pageCount1); //페이지 그룹
    let last = pageGroup * pageCount1;

    if (last > totalPage) {
      last = totalPage;
    }

    let first = last - (pageCount1 - 1); //화면에 보여질 첫번째 페이지 번호

    const next = last + 1;
    // const prev = first - 1;

    if (totalPage < 1) {
      first = last;
    }

    if (first > pageCount1) {
    } else {
    }

    if (next > pageCount1 && next < totalPage) {
    } else {
    }

    for (let j = first; j <= last; j++) {
      pageNumbers.push(j);
    }

    const list = pageNumbers.map((num, index) => {
      return (
        <span
          key={index}
          style={{ cursor: "pointer" }}
          onClick={() => this._getData(num)}
          className={gotoPage === num ? "on" : null}
        >
          {num}
        </span>
        /*<a href="#" className={gotoPage === num ? "active" : null } onClick={()=>this._page(num)} key={index}>{num}</a>*/
      );
    });

    return (
      <Fragment>
        {first > pageCount1 ? (
          <span onClick={this._onPrev}>이전</span>
        ) : (
          <span style={{ backgroundColor: "#000" }}></span>
        )}
        {list}
        {next > pageCount1 && next < totalPage ? (
          <span onClick={this._onNext}>다음</span>
        ) : (
          <span style={{ backgroundColor: "#000" }}></span>
        )}
      </Fragment>
    );
  };

  _onPrev = () => {
    const { gotoPage } = this.state;

    if (gotoPage === 1) {
      //alert('페이지의 처음입니다.')
      toast.warn("페이지의 처음입니다.");
    } else {
      this._getData(gotoPage - 1);
    }
  };
  _onNext = () => {
    const { gotoPage, pageCount } = this.state;
    if (gotoPage + 1 >= pageCount) {
      toast.warn("페이지의 마지막입니다.");
      //alert('페이지의 마지막입니다.')
    } else {
      this._getData(gotoPage + 1);
    }
  };

  _onPrev = () => {
    const { gotoPage } = this.state;

    if (gotoPage === 1) {
      //alert('페이지의 처음입니다.')
      toast.warn("페이지의 처음입니다.");
    } else {
      this._getData(gotoPage - 1);
    }
  };
  _onNext = () => {
    const { gotoPage, pageCount } = this.state;
    if (gotoPage + 1 >= pageCount) {
      toast.warn("페이지의 마지막입니다.");
      //alert('페이지의 마지막입니다.')
    } else {
      this._getData(gotoPage + 1);
    }
  };
  _CommaFormatted = (str) => {
    ////console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = "";
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = "," + (parseInt(str) % 1000) + "00" + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = "," + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ",0" + (parseInt(str) % 1000) + Money;
          else Money = ",00" + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };
  _setting = () => {
    const { setSettingShow } = this.props;

    setSettingShow(true);
  };
  render() {
    // const { tabIndex } = this.props.childProps;
    const { dataList, con, cash } = this.state;
    return (
      <Fragment>
        <div className="list_wrap">
          <div className="listHead">
            <span className="total">
              총 <em>{con}</em>명
            </span>
            <span className="friends_cash">
              친구추천 누적포인트 : <b>{this._CommaFormatted(cash)}</b>포인트
            </span>
            <div className="fl_rt">
              <span className="friends_share">
                내친구들과 나의 찜한작품을 공유하고싶으면
                <br />
                설정에서 공유하기로 변경해주세요
              </span>
              <button type="button" className="btn_on" onClick={this._setting}>
                설정 변경하기
              </button>
            </div>
          </div>
          <div className="list">
            <table className="friends_current">
              <thead>
                <tr>
                  <th>아이디</th>
                  <th>결제일</th>
                  <th>결제내역</th>
                  <th>찜한 작품 공유</th>
                </tr>
              </thead>
              <tbody>{dataList ? this._renderItem() : null}</tbody>
            </table>
          </div>
          <div className="page_no">{dataList ? this._renderPage() : null}</div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(MyFriendList)));
